import { render, staticRenderFns } from "./UploadMultipleFile.vue?vue&type=template&id=2f173965"
import script from "./UploadMultipleFile.vue?vue&type=script&lang=js"
export * from "./UploadMultipleFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports